import { ECrudType } from 'redux/actions/crud';
import shiftMapper from 'redux/mappers/shift';
import { GetReducer, ICrudState } from './crud';
import moment from 'moment';
import { DATETIME_FORMAT } from 'utils/date';
import { getDurationDisplay } from 'components/atom/duration-dropdown';

export interface IShiftState extends ICrudState {
  today?: boolean;
}

const reducer = GetReducer(
  ECrudType.shifts,
  shiftMapper,
  (obj: any) => ({
    ...obj,
    dropdown: `${moment(obj.startDate).format(DATETIME_FORMAT)} - ${getDurationDisplay(obj.duration / 60)}`,
  }),
  (state: any, action: any) => {
    switch (action.type) {
      case ECrudType.shifts + '_TODAY':
        return {
          ...state,
          today: action.payload,
        };
    }
  },
);

export default reducer;
